// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textEditorContainor {
    height: 250px;
}

.textEditorContainor div {
    /* border-radius: 5px; */
}

.ql-toolbar{
    border-radius: 5px 5px 0 0 !important;
}

.ql-container{
    border-radius: 0 0 5px 5px !important;
}

.ql-snow .ql-tooltip {
    z-index: 99 !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/TextEditor/TextEditor.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".textEditorContainor {\n    height: 250px;\n}\n\n.textEditorContainor div {\n    /* border-radius: 5px; */\n}\n\n.ql-toolbar{\n    border-radius: 5px 5px 0 0 !important;\n}\n\n.ql-container{\n    border-radius: 0 0 5px 5px !important;\n}\n\n.ql-snow .ql-tooltip {\n    z-index: 99 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
